import React from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { useAuth } from '../contexts/AuthContext';
import { defaultPathForRole, roleOf } from '../utils/roles';

function ToHome() {
  const { user } = useAuth();
  return <Navigate to={defaultPathForRole(roleOf(user))} replace />;
}

// "/": everyone starts at Home. The redirect waits until the session has been read, so the role is known before anyone
// is sent anywhere.
export default function HomeRedirect() {
  return (
    <ProtectedRoute>
      <ToHome />
    </ProtectedRoute>
  );
}
